import Aerra from '../../media/Aerra.png'
import Namee from '../../media/Namee.png'

const clusterimages =[
Namee,Aerra
]

export default clusterimages;